import * as React from "react";
const SvgSelectLanguage = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "select_language_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "select_language_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20 3H4a2 2 0 0 0-2 2v15a2 2 0 0 0 3.21 1.67L11.89 17H20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 12h-8.13a1.9 1.9 0 0 0-1.11.35L4 20.08V5h16Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m6.31 12.62 2.14-5h1.41l2.14 5h-1.27l-.4-1H8l-.38 1Zm1.93-1.72h1.85l-.94-2.39ZM17.05 9.07h.71v-1h-1.88v-.69h-1v.69H13v1h3a2.8 2.8 0 0 1-.89 1.45 7.5 7.5 0 0 1-.76-1l-.86.51a9 9 0 0 0 .86 1.15 9 9 0 0 1-1.34.76l.4.92a10 10 0 0 0 1.64-1 3.76 3.76 0 0 0 1.9 1l.14-1a2.64 2.64 0 0 1-1.26-.65 3.62 3.62 0 0 0 1.22-2.14",
	style: { fill: "currentColor" }
}))));
export default SvgSelectLanguage;
